var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome1 = function SvgHome1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.743 8.608c0 .607-.508 1.082-1.083 1.082h-1.084l.024 5.394c0 .094-.007.182-.017.273v.545a1.35 1.35 0 0 1-1.354 1.348h-.541c-.038 0-.075-.03-.112-.003-.048-.027-.095.003-.142.003H13.52a1.35 1.35 0 0 1-1.354-1.348v-2.964a1.08 1.08 0 0 0-1.084-1.079H8.917c-.6 0-1.084.482-1.084 1.079v2.964A1.35 1.35 0 0 1 6.48 17.25H4.587q-.077 0-.153-.007-.06.007-.122.007h-.541a1.35 1.35 0 0 1-1.354-1.348V12.13c0-.03 0-.064.003-.094V9.69H1.335A1.07 1.07 0 0 1 .25 8.608c0-.303.102-.573.339-.808L9.269.27c.237-.236.508-.27.745-.27s.507.068.714.236L19.37 7.8c.27.235.41.505.372.808"
  })));
};
export default SvgHome1;